"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputType = exports.CommitmentType = exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType[TokenType["ERC20"] = 0] = "ERC20";
    TokenType[TokenType["ERC721"] = 1] = "ERC721";
    TokenType[TokenType["ERC1155"] = 2] = "ERC1155";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
var CommitmentType;
(function (CommitmentType) {
    CommitmentType["ShieldCommitment"] = "ShieldCommitment";
    CommitmentType["TransactCommitment"] = "TransactCommitment";
    CommitmentType["LegacyEncryptedCommitment"] = "LegacyEncryptedCommitment";
    CommitmentType["LegacyGeneratedCommitment"] = "LegacyGeneratedCommitment";
})(CommitmentType = exports.CommitmentType || (exports.CommitmentType = {}));
var OutputType;
(function (OutputType) {
    OutputType[OutputType["Transfer"] = 0] = "Transfer";
    OutputType[OutputType["RelayerFee"] = 1] = "RelayerFee";
    OutputType[OutputType["Change"] = 2] = "Change";
})(OutputType = exports.OutputType || (exports.OutputType = {}));
